export const T = {
  en_GB: {
    title: "Currency Fees",
    description:
      "Fees applied when converting currency to buy or sell. Leave empty for none. Used when buying and selling products in a different currency than the account currency.",
    buyFee: "Buy FX Fee",
    sellFee: "Sell FX Fee",
    none: "None",
    invalid: "Fees must be greater than 0 and at most 5",
    saved: "Saved",
    failedToSave: "Failed to save currency fees",
    saving: "Saving...",
    save: "Save",
  },
  nb_NO: {
    title: "Valutagebyrer",
    description:
      "Gebyrer som påløper ved valutaveksling for kjøp eller salg. La stå tom for ingen. Brukes ved kjøp og salg av produkter i en annen valuta enn kontovalutaen.",
    buyFee: "Kjøpsgebyr (FX)",
    sellFee: "Salgsgebyr (FX)",
    none: "Ingen",
    invalid: "Gebyrer må være større enn 0 og høyst 5",
    saved: "Lagret",
    failedToSave: "Kunne ikke lagre valutagebyrer",
    saving: "Lagrer...",
    save: "Lagre",
  },
} as const;
